import { render, staticRenderFns } from "./StandartDynamicPageContainer.vue?vue&type=template&id=745e0033&"
import script from "./StandartDynamicPageContainer.vue?vue&type=script&lang=js&"
export * from "./StandartDynamicPageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports